import { render } from "./DatabaseShop.vue?vue&type=template&id=c8bcdafa&scoped=true&ts=true"
import script from "./DatabaseShop.vue?vue&type=script&lang=ts"
export * from "./DatabaseShop.vue?vue&type=script&lang=ts"

import "./DatabaseShop.vue?vue&type=style&index=0&id=c8bcdafa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8bcdafa"]])

export default __exports__